import { HeaderNavigationTopicLink } from '@/packages/Header/src/HeaderNavigationTopic';
import { Mixin as HeaderMixin } from '@owc-types/Header';
import { FlyoutLevels } from '@/packages/Header/src/Header.enums';
import { OwcComponentMixinData } from './OwcComponent';
import { BaseDataJson } from '@/packages/_types/BaseDataJSON';
import { ComponentOptionsWithProps, ComputedGetter } from 'vue/types/v3-component-options';
import { TrackingMixinMethods } from '@owc-utils/Mixins/Tracking';

export type DataJSON = Partial<BaseDataJson> & {
  currentFlyoutLevel: number;
  links: HeaderNavigationTopicLink[];
  headline: string;
};

export type HeaderNavigationToolListComputed = {
  currentFlyoutLevel: ComputedGetter<number>;
  nextFlyoutLevel: ComputedGetter<number>;
  links: ComputedGetter<HeaderNavigationTopicLink[]>;
  headline: ComputedGetter<string>;
};

export type HeaderNavigationToolListMethods = {
  handleLinkClick: (link: HeaderNavigationTopicLink) => void;
};

const mixin: ComponentOptionsWithProps<
  {},
  {},
  OwcComponentMixinData<DataJSON>,
  HeaderNavigationToolListComputed,
  HeaderNavigationToolListMethods & Partial<TrackingMixinMethods & HeaderMixin>,
  {},
  {},
  {}
> = {
  computed: {
    links() {
      return this.componentData?.links;
    },
    headline() {
      return this.componentData?.headline;
    },
    currentFlyoutLevel() {
      if (this.componentData?.currentFlyoutLevel) {
        return this.componentData?.currentFlyoutLevel;
      }
      return FlyoutLevels.FLYOUT_LEVEL_ONE;
    },
    nextFlyoutLevel() {
      if (this.currentFlyoutLevel) {
        return this.currentFlyoutLevel + 1;
      }
      return FlyoutLevels.FLYOUT_LEVEL_THIRD;
    },
  },
  methods: {
    handleLinkClick(link) {
      if (this.addAndSubmitTrackingTree) {
        this.addAndSubmitTrackingTree(
          {
            label: link.label,
            url: link.url,
          },
          this.nextFlyoutLevel,
        );
      }
    },
  },
};

export default mixin;
